<template>
	<!-- mixin item(icon=false, title=false, description=false) -->
	<router-link class="panel__wrapper" :to="route" :class="{ active: isActive }">
		<div class="panel__inner--horizontal">
			<div class="panel__header" v-if="icon">
				<div class="panel__icon">
					<img :src="BASE_URL + icon" alt="">
				</div>
			</div>

			<div class="panel__body">
				<div class="panel__title" v-if="title">{{title}}</div>
				<div class="panel__description" v-html="description"></div>
			</div>
		</div>
	</router-link>
</template>

<script>
export default {
	name: "CertificadosItem",
	props: [ "icon", "title", "description", "route", "isActive" ],
	data: () => {
		return {
			BASE_URL: process.env.BASE_URL + 'images/'
		}
	}
}
</script>